import { ReactElement } from 'react';

import { IconsPropsI } from './interfaces';

const CircleCheckIcon = ({
  width = 32,
  height = 32,
  fill = '#1F61F7',
  alternativeFill = 'white',
}: IconsPropsI): ReactElement => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16 4C9.376 4 4 9.376 4 16C4 22.624 9.376 28 16 28C22.624 28 28 22.624 28 16C28 9.376 22.624 4 16 4Z"
        fill={fill}
      />
      <path
        d="M14.0302 21.6643C13.5858 22.1119 12.868 22.1119 12.4236 21.6643L8.33325 17.5443C8.1199 17.3299 8 17.0388 8 16.7353C8 16.4317 8.1199 16.1406 8.33325 15.9262C8.77761 15.4786 9.49543 15.4786 9.93979 15.9262L13.2212 19.2314L21.0602 11.3357C21.5046 10.8881 22.2224 10.8881 22.6667 11.3357C23.1111 11.7833 23.1111 12.5063 22.6667 12.9538L14.0302 21.6643Z"
        fill={alternativeFill}
      />
    </svg>
  );
};

export default CircleCheckIcon;
